// @flow
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
// import PrintGoalcard from 'components/shared/PrintGoalcard/index';
import bgImage from 'assets/images/background.png';
import { sendAnalyticsEvent } from 'utils/analyticsWrapper';
import { formatToCurrency } from 'utils/numbers';
import { ReactComponent as Test } from 'assets/images/success-give-goalcard/container-free-goalcard-mobile.svg';

import {
  PageContainer,
  SuccessContainer,
  GoalcardContainer,
  TitleContainer,
  InfoContainer,
  Title,
  TitleBold,
  Description,
  Button,
  SupportLabelContainer,
  SupportLabel,
  SupportEmail,
  GoalcardImage,
} from './Styles';

type SuccessPageProps = {
  purchasedGoalcard: { amount: Number, kidFirstName: string, GoalcardImg: string },
};

const SuccessPageMobile = (props: SuccessPageProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { purchasedGoalcard, goalcardPayload } = props || {};

  // purchasedGoalcard = {
  //   amount: 20,
  //   kidFirstName: 'Pepito',
  //   goalcardImg: 'https://s3.amazonaws.com/goalcardimages/HappyHanukkah.jpg',
  //   isClaimed: false,
  // };

  if (purchasedGoalcard == null) {
    history.push('/gift');
  }

  const onClick = () => {
    sendAnalyticsEvent('Success Purchase', 'success_purchase_give_another');
    history.push('/gift');
  };

  const {
    kidFirstName,
    amount,
    goalcardImg,
    isClaimed,
  } = purchasedGoalcard || {};

  const { executionDate } = goalcardPayload || {};

  let title = '';
  let confirmationTitle = '';
  let firstnameWithPossesive = '';
  let amountWithCurrencySymbol = '';

  if (amount) {
    amountWithCurrencySymbol = formatToCurrency(amount.toFixed(2), true);
  }

  if (kidFirstName) {
    firstnameWithPossesive = kidFirstName.endsWith('s') ? `${kidFirstName}'` : `${kidFirstName}'s`;
  }

  if (amount) {
    const amountFormatted = formatToCurrency(amount.toFixed(2), false);
    if (executionDate && executionDate !== '') {
      title = t('success_infoscheduled_title', { goalcardAmount: amountFormatted, firstname: kidFirstName, scheduledDate: moment(executionDate).format('L') });
      confirmationTitle = t('success_confirmationscheduled_description', { firstname: kidFirstName });
    } else {
      title = t('success_info_title_part1');
      confirmationTitle = t('success_confirmation_description', { firstname: kidFirstName });
    }
  }

  const renderTitleContainer = () => (
    <TitleContainer>
      {/* <Title data-testid="lblTitle">{t('success_congrats_title')}</Title> */}
      <Title>
        {title}
        <TitleBold>
          {amountWithCurrencySymbol}
        </TitleBold>
        {` ${t('success_info_title_part2')}`}
        <TitleBold>
          {` ${firstnameWithPossesive} ${t('success_info_title_part3')}`}
        </TitleBold>
        {' '}
      </Title>
    </TitleContainer>
  );

  return (
    <PageContainer backgroundImage={bgImage}>

      <SuccessContainer isMobile>
        {renderTitleContainer()}
        <GoalcardContainer>
          <GoalcardImage src={goalcardImg} />
        </GoalcardContainer>
        <InfoContainer isMobile>
          <Description>{confirmationTitle}</Description>
          {
            (isClaimed === false && (!executionDate || executionDate === '')) && <Description>{t('success_confirmationemail_description')}</Description>
          }
        </InfoContainer>
      </SuccessContainer>
      <div>
        <Button data-testid="btnGiveAnotherGoal" onClick={onClick}>{t('success_givegoalcard_title')}</Button>
      </div>
      <Test style={{ width: '100%', height: '100%' }} />
      <div style={{ marginTop: '-80px' }}>
        <Button data-testid="btnDownloadApp" href={`${process.env.REACT_APP_DOWNLOAD_APP_LINK}`}>{t('success_downloadapp_title')}</Button>
      </div>
      <SupportLabelContainer>
        <SupportLabel>
          {t('success_supportpartone_title')}
          <SupportEmail href="mailto:hello@goalsetter.co">hello@goalsetter.co</SupportEmail>
          {t('success_supportparttwo_title')}
        </SupportLabel>
      </SupportLabelContainer>
    </PageContainer>

  );
};

// Map Props
const mapStateToProps = (state) => ({
  purchasedGoalcard: state.purchase.purchasedGoalcard,
  goalcardPayload: state.purchase.goalcardPayload,
});

// Map Dispatch
const mapDispatchToProps = () => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuccessPageMobile);
